import { useCookieSettings } from '@lalalilo/front-utils'
import { parse, stringify } from 'qs'
import { useCallback } from 'react'
import { TEACH_APP_URI } from './config'

export enum TeachAppPath {
  PORTAL = '/portal',
  GLOBAL_SIGN_UP = '/signup-choices',
  FRENCH_SIGN_UP = '/signup',
}

export const useTeachAppLink = () => {
  const [cookieSettings] = useCookieSettings()

  let tracking = 'none'
  if (cookieSettings === true) {
    tracking = 'allowed'
  }
  if (cookieSettings === false) {
    tracking = 'disallowed'
  }

  return useCallback(
    (relativePath: TeachAppPath) =>
      `${TEACH_APP_URI}${relativePath}?${stringify({
        ...parse(window.location.search),
        tracking,
      })}`,
    [tracking]
  )
}

export const P2IA_APP_URL = process.env.REACT_APP_P2IA_APP_URL
  ? `https://${process.env.REACT_APP_P2IA_APP_URL}`
  : 'http://localhost:3004'
